export default __webpack_public_path__ + "static/Vidrios_Aluminios_4-b4a4bb9ecbdc94d104df2272be065204.png";